import { useState ,useEffect} from "react";
import { Outlet, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import "./workshop-dashboard.css";
import CreateCaseModal from "../../../Component/Workshop/Cases/CreateCaseModal";
import NotificationPanel from "../../../Component/Workshop/Notifications/NotificationPanel";
import { useNotifications } from "../../../hooks/useWorkshopQueries";

const NAV = [
  { path: "/admin/workshop-dashboard", label: "Dashboard",        icon: HomeIcon },
  { path: "/admin/cases",        label: "Cases",            icon: CasesIcon },
  { path: "/admin/documents",    label: "Documents",        icon: DocsIcon },
  { path: "/admin/workshops",    label: "Workshops",        icon: WorkshopIcon },
  { path: "/admin/surveyors",    label: "Surveyors",        icon: SurveyorIcon },
  // { path: "/admin/vehicle-movement", label: "Vehicle Movement", icon: TruckIcon },
  { path: "/admin/claims",       label: "Claims & Payments",icon: ClaimsIcon },
  { path: "/admin/reports",      label: "Reports",          icon: ReportsIcon },
  // { path: "/admin/settings",     label: "Settings",         icon: SettingsIcon },
];

export default function AdminLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [createOpen, setCreateOpen] = useState(false);
  
  const [notifOpen, setNotifOpen] = useState(false);
  const { data: notifData } = useNotifications({});
  const unreadCount = notifData?.unreadCount || 0;
  const userId = localStorage.getItem("userId");
const token = localStorage.getItem("token");

const displayName = localStorage.getItem("name") || "Admin User";
const userRole = localStorage.getItem("department") || "Administrator";
 
const getInitials = (name) => {
  if (!name) return "A";
  const parts = name.trim().split(" ");
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
};
  // Mark "Cases" active for both /admin/cases and /admin/cases/:id
  const isActive = (path) => {
    if (path === "/admin/cases") return location.pathname.startsWith("/admin/cases");
    return location.pathname === path || location.pathname.startsWith(path + "/");
  };

  const isSearchablePath = [
    "/admin/workshop-dashboard",
    "/admin/cases",
    "/admin/documents",
    "/admin/workshops",
    "/admin/surveyors",
    "/admin/claims",
  ].some((path) => location.pathname === path || location.pathname.startsWith(path + "/"));
  const isDashboardPath = location.pathname === "/admin/workshop-dashboard";

  const globalSearch = searchParams.get("q") || "";
  const handleGlobalSearchChange = (value) => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        if (value?.trim()) next.set("q", value);
        else next.delete("q");
        return next;
      },
      { replace: true }
    );
  };

  const handleGlobalSearchKeyDown = (e) => {
    if (e.key !== "Enter") return;
    if (!globalSearch.trim()) return;
    if (isDashboardPath) {
      navigate(`/admin/cases?q=${encodeURIComponent(globalSearch.trim())}`);
    }
  };

  return (
    <div className="wd-root">
      {/* ── Sidebar ── */}
      <aside className="wd-sidebar">
        <div className="wd-logo"
         onClick={() => navigate('/admin-dashboard-vendor-customer')}
         style={{ cursor: 'pointer' }}>
          <div
            style={{
              width: 34,
              height: 34,
              borderRadius: 9,
              background: "linear-gradient(135deg, #1d4ed8 0%, #3b82f6 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <WorkshopIcon />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <div style={{ display: "flex", alignItems: "baseline", gap: 4 }}>
              <span
                style={{ fontSize: 15, fontWeight: 800, color: "var(--wd-t1)", letterSpacing: "-0.2px", }}
              >
                ClaimPro
              </span>
              <span
                style={{ fontSize: 15, fontWeight: 600, color: "var(--wd-t2)" }}
              >
                Assist
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
              <div style={{ width: 14, height: 2, borderRadius: 2, background: "linear-gradient(90deg, #3b82f6, #7c3aed)", flexShrink: 0 }} />
                <span style={{ fontSize: 12,fontWeight: 400, color: "var(--wd-t3)", fontStyle: "italic", lineHeight: 1 }}>
                  दुर्घटना से समाधान तक
                </span>
              </div>
          </div>
        </div>

        <nav className="wd-nav">
          {NAV.map(({ path, label, icon: Icon }) => (
            <button
              key={path}
              className={`wd-nav-item ${isActive(path) ? "active" : ""}`}
              onClick={() => navigate(path)}
            >
              <Icon />
              <span>{label}</span>
            </button>
          ))}
        </nav>

        <div className="wd-sidebar-footer">
          <button
            className="wd-btn wd-btn-primary"
            style={{ width: "100%", justifyContent: "center" }}
            onClick={() => setCreateOpen(true)}
          >
            <PlusIcon /> Create Case
          </button>
        </div>
      </aside>

      {/* ── Main ── */}
      <div className="wd-main">
        {/* Navbar */}
        <header className="wd-navbar">
          <div className="wd-search-wrap">
            <SearchIcon />
            <input
              className="wd-search-input"
              placeholder={isDashboardPath ? "Search and press Enter for cases..." : "Search case, vehicle, phone..."}
              value={globalSearch}
              onChange={(e) => handleGlobalSearchChange(e.target.value)}
              onKeyDown={handleGlobalSearchKeyDown}
              disabled={!isSearchablePath}
            />
          </div>
          <div className="wd-navbar-right">
            <button className="wd-icon-btn" title="Notifications">
              <BellIcon />
              <span className="wd-notif-dot" />
            </button>
            <button
              className="wd-icon-btn"
              title="Email Notifications"
              onClick={() => setNotifOpen(true)}
              style={{ position: "relative" }}
            >
              <MailIcon />
              {unreadCount > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: 2,
                    right: 2,
                    fontSize: 9,
                    fontWeight: 800,
                    color: "#fff",
                    background: "#ef4444",
                    borderRadius: 10,
                    padding: "0 5px",
                    minWidth: 16,
                    textAlign: "center",
                    lineHeight: "16px",
                  }}
                >
                  {unreadCount > 99 ? "99+" : unreadCount}
                </span>
              )}
            </button>
            <div className="wd-user-pill">
              <div
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  background: "#3b82f6",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 13,
                  fontWeight: 700,
                  color: "#fff",
                }}
              >
                 {getInitials(displayName)} 
              </div>
              <div>
                <div className="wd-user-name">{displayName}</div>
               <div className="wd-user-role">{userRole}</div>
              </div>
            </div>
          </div>
        </header>

        {/* Page content */}
        <main className="wd-page">
          <Outlet />
        </main>
      </div>
      <CreateCaseModal open={createOpen} onClose={() => setCreateOpen(false)} />
      <NotificationPanel open={notifOpen} onClose={() => setNotifOpen(false)} />
    </div>
  );
}

// ── Icons ──────────────────────────────────────────────────────────────────────
function HomeIcon()     { return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>; }
function CasesIcon()    { return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/></svg>; }
function DocsIcon()     { return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>; }
function WorkshopIcon() { return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg>; }
function SurveyorIcon() { return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>; }
function TruckIcon()    { return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>; }
function ClaimsIcon()   { return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/></svg>; }
function ReportsIcon()  { return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>; }
function SettingsIcon() { return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 01-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg>; }
function SearchIcon()   { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>; }
function BellIcon()     { return <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 01-3.46 0"/></svg>; }
function MailIcon()     { return <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>; }
function PlusIcon()     { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>; }